import { render } from "./shows.vue?vue&type=template&id=3e4ac1f0"
import script from "./shows.vue?vue&type=script&lang=js"
export * from "./shows.vue?vue&type=script&lang=js"

import "./shows.vue?vue&type=style&index=0&id=3e4ac1f0&lang=scss&scooped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__